import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Row, Col } from 'antd';
import getFormData from 'get-form-data';

import FieldsGroup from '@atoms/form/fields-group';

import { fieldChange, fieldValidation, NUMBER_RULES, responseError } from 'FIELDS';
import { InputsSet } from 'INPUTS';
import { tConsume } from 'TRANSLATION';
import defaults from 'DEFAULTS';
import './tfaQr.less';
import axios from 'axios';
import api from 'API';

class TfaQrFormPreregistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tfa_code: {
        name: 'tfa_code',
        type: 'number',
        accept: defaults.re.digits,
        required: true,
        placeholder: true,
        label: props.t('field.code'),
        [NUMBER_RULES.LENGTH]: 6,
        autofocus: true,
      },
    };

    this.handleFieldChange = fieldChange.bind(this, this);
    this.fieldValidation = fieldValidation.bind(this, this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.responseError = responseError.bind(this, this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this._counterInterval);
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { email, password, userType } = this.props;
    const data = getFormData(event.target, { trim: true });
    console.log(data);

    if (!!data && this.fieldValidation()) {
      const payload = {
        tfa_code: data.tfa_code,
        email: email.value,
        password: password.value,
      };

      try {
        if (this._mounted) {
          const response = await axios(api.tfa.checkGoogleAuthTfa2(userType).AXIOS('POST', payload));

          sessionStorage.setItem('magma-token', response.data.token);

          this.props.successCallback();
        }
      } catch (error) {
        if (this._mounted) {
          this.responseError(error);
        }
      }
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      tfa_code: { ...prevState.tfa_code, value: null },
    }));
  }

  render() {
    const { loading, t } = this.props;
    const { tfa_code } = this.state;

    return (
      <div className='qr-wrapper'>
        <div className='setup-2fa'>
          <div className='step'>
            <div className='step-circle'>1</div>
            <div className='step-content'>
              <div className='step-header'>
                <span className='step-label'>STEP 1</span>
                <h3 className='step-title'>Download Google Authenticator app</h3>
              </div>
              <p className='step-description'>You can download it to your device from the App Store and Google Play.</p>
            </div>
          </div>

          <div className='step'>
            <div className='step-circle'>2</div>
            <div className='step-content'>
              <div className='step-header'>
                <span className='step-label'>STEP 2</span>
                <h3 className='step-title'>Verification with Authenticator App</h3>
              </div>
              <p className='step-description'>Enter the 6-digit code generated by your authenticator app.</p>
            </div>
          </div>
        </div>

        <div className='qr-block'>
          <Form onSubmit={this.handleSubmit}>
            <FieldsGroup title={`${t('component.tfa.google_description')}`} />
            <Row gutter={20}>
              <Col sm={16}>{InputsSet(this, ['tfa_code'])}</Col>
              <Col sm={8}>
                <Button
                  size={defaults.antd.button.size}
                  loading={loading}
                  htmlType={'submit'}
                  type={'primary'}
                  disabled={tfa_code.value?.length !== 6}
                  block
                >
                  {t('button.confirm')}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

export default tConsume(TfaQrFormPreregistration);

TfaQrFormPreregistration.propTypes = {
  email: PropTypes.object.isRequired,
  password: PropTypes.string.isRequired,
  successCallback: PropTypes.func.isRequired,
};

TfaQrFormPreregistration.defaultProps = {
  loading: false,
};
